<template>
    <div class="panel-content">
        <h2>Wat ons uniek maakt</h2>
        <img class="header" src="/static/img/overlay-assets/header3-4.jpg" />
        <p>Wij verkopen de unieke apparatuur die het onze klanten mogelijk maakt om nieuwe medische isotopen te verwerken. Een belangrijk voorbeeld daarvan is de CISSPECT® Desklab, die wij in opdracht van, en in nauwe samenwerking met, NRG hebben ontwikkeld.</p>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

    };
</script>
